import { API_CONFIG } from '../api/config';

function getPublicFileUrl(filePath) {
  const normalizedPath = String(filePath || '').trim().replace(/^\/+/, '');

  if (!normalizedPath) {
    return '';
  }

  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath;
  }

  const baseUrl = String(API_CONFIG.publicBaseUrl || '').replace(/\/+$/, '');

  return `${baseUrl}/get-file/public/${encodeURI(normalizedPath)}`;
}

export function getCurrencyIconUrl(currency) {
  const filePath = currency?.iconFilePath
    || currency?.file?.keys?.orig
    || currency?.file?.keys?.original
    || '';
  const directUrl = currency?.iconUrl
    || currency?.file?.urls?.orig
    || currency?.file?.urls?.original
    || currency?.file?.url
    || '';

  return getPublicFileUrl(filePath) || directUrl;
}
